export default __webpack_public_path__ + "static/media/WordGames_21.c1009249.png";